import { render, staticRenderFns } from "./InwardRem.vue?vue&type=template&id=21ae632a&scoped=true&"
import script from "./InwardRem.vue?vue&type=script&lang=js&"
export * from "./InwardRem.vue?vue&type=script&lang=js&"
import style0 from "./InwardRem.vue?vue&type=style&index=0&id=21ae632a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae632a",
  null
  
)

export default component.exports